'use strict';

function setChainableConstructor(sugarNamespace, createFn) {
  sugarNamespace.prototype.constructor = function() {
    return createFn.apply(this, arguments);
  };
}

module.exports = setChainableConstructor;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/common/internal/setChainableConstructor.js
// module id = 262
// module chunks = 0